import { Form, Input, Button, Alert, Row, Col } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { HeartOutlined } from "@ant-design/icons";
import { SignedInDoctor } from "../auth/interfaces";
import { SignedInContext } from "../AppEnv";
import { updateDoctorData } from "./utils";

type SizeType = Parameters<typeof Form>[0]["size"];

enum OpStatus {
  UNKNOWN,
  SUCCESS,
  ERROR,
}

const boostWithDData = (doc: SignedInDoctor) => {
  doc.telephoneD =
    doc.telephone != undefined &&
    doc.telephone.length == 13 &&
    doc.telephone[0] == "+"
      ? doc.telephone.substring(3) //delete prefix from visualization, e.g. +39
      : doc.telephone;

  doc.websiteD =
    doc.website != undefined && doc.website.startsWith("http://")
      ? doc.website.substring("http://".length) //delete prefix from visualization, e.g. +39
      : doc.website;

  return doc;
};

const EditDoctorInfo = () => {
  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;
  const setSignedInDoctor = useContext(SignedInContext).setSignedInDoctor;
  const [editedDoctor, setEditedDoctor] = useState(
    boostWithDData(signedInDoctor)
  );
  console.log(" Edit Normal IN");
  const [updateMsg, setUpdateMsg] = useState({
    msg: "",
    state: OpStatus.UNKNOWN,
  });
  const onFormLayoutChange = () => {};

  const onFinish = async () => {
    //console.log("Updated doc info:", editedDoctor);
    const updatedDoctor: SignedInDoctor = await updateDoctorData(editedDoctor);
    if (updatedDoctor.id == signedInDoctor.id) {
      updatedDoctor.token = signedInDoctor.token;
      if (setSignedInDoctor) setSignedInDoctor(updatedDoctor);
      setUpdateMsg({
        msg: "Aggiornamento eseguito con successo",
        state: OpStatus.SUCCESS,
      });
    } else {
      setUpdateMsg({
        msg: "Aggiornamento non riuscito",
        state: OpStatus.ERROR,
      });
    }
  };

  return (
    <>
      <div style={{ margin: "15px" }}>
        <Form
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 14 }}
          layout="horizontal"
          onValuesChange={onFormLayoutChange}
          size={"large" as SizeType}
          onFinish={onFinish}
        >
          <Form.Item
            label="Anagrafica"
            rules={[
              {
                required: true,
                message:
                  "Anagrafica di base necessaria per identificare l'utente!",
              },
            ]}
          >
            <Input
              type={"text"}
              placeholder={"Nome"}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setEditedDoctor({ ...editedDoctor, name: e.target.value })
              }
              defaultValue={editedDoctor.name}
              required
            />
            <Input
              type={"text"}
              placeholder={"Cognome"}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setEditedDoctor({ ...editedDoctor, surname: e.target.value })
              }
              defaultValue={editedDoctor.surname}
              required
            />
          </Form.Item>
          <Form.Item
            label="Contatti"
            rules={[
              {
                required: true,
                message:
                  "Inserire un contatto mail è necessario per poter poi recuperare l'account!",
              },
            ]}
          >
            <Input
              type={"email"}
              placeholder={"Email"}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setEditedDoctor({ ...editedDoctor, email: e.target.value })
              }
              defaultValue={editedDoctor.email}
            />
            <Input
              type={"text"}
              placeholder={"Contatto telefonico"}
              addonBefore={"+39"}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setEditedDoctor({
                  ...editedDoctor,
                  telephone: "+39" + e.target.value,
                })
              }
              defaultValue={editedDoctor.telephoneD}
            />
            <Input
              type={"text"}
              placeholder={"Pagina web"}
              addonBefore={"http://"}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setEditedDoctor({
                  ...editedDoctor,
                  website: "http://" + e.target.value,
                })
              }
              defaultValue={editedDoctor.websiteD}
            />
          </Form.Item>
          <Form.Item className="label-transparent" label="Conferma">
            <Button
              type={"primary"}
              className={"primary login-form-button"}
              htmlType={"submit"}
              style={{
                width: "60%",
                marginLeft: "20%",
                marginRight: "20%",
                textAlign: "center",
              }}
            >
              Aggiorna
            </Button>
          </Form.Item>
          {updateMsg.state != OpStatus.UNKNOWN && (
            <Form.Item className="label-transparent" label="Conferma">
              <Alert
                message={updateMsg.msg}
                type={updateMsg.state == OpStatus.SUCCESS ? "success" : "error"}
                style={{
                  textAlign: "center",
                  margin: "auto",
                  width: "40%",
                  marginLeft: "30%",
                  marginRight: "30%",
                }}
                showIcon
              />
            </Form.Item>
          )}
        </Form>
      </div>
    </>
  );
};

export default EditDoctorInfo;
